<template>
  <v-flex pl-2 pr-2 pt-2 pb-2>
    <span class="subheading" v-html="title"></span>
    <v-layout wrap>
      <v-chip
        disabled
        outline
        label
        small
        v-if="primaryChip !== '' && primaryChip !== null && primaryChip !== undefined"
        color="primary"
        text-color="primary">
        <span v-html="primaryChip"></span>
      </v-chip>
      <v-chip
        disabled
        outline
        label
        small
        v-if="greenChip !== '' && greenChip !== null && greenChip !== undefined"
        color="green"
        text-color="green">
        <span v-html="greenChip"></span>
      </v-chip>
      <v-chip
        disabled
        outline
        label
        small
        v-if="pinkChip !== '' && pinkChip !== null && pinkChip !== undefined"
        color="pink"
        text-color="pink">
        <span v-html="pinkChip"></span>
      </v-chip>
      <v-layout class="body-1 gray--text" align-end justify-end>{{ date }}</v-layout>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'DeliveryListItem',
  props: ['title', 'primaryChip', 'greenChip', 'pinkChip', 'date']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeliveryListItem.vue